import dynamic from "next/dynamic";

export const Phone = dynamic(() => import("./component"));
